import {
  Button,
  FormControl,
  FormLabel,
  IconButton,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Spinner,
  Stack,
  useDisclosure,
} from "@chakra-ui/react";
import { FormEvent, useState } from "react";
import { MdUpdate } from "react-icons/md";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getAddQuestionData } from "redux/slices/AddQuestionSlice";

import React from "react";
import {
  selectUpdateFormationData,
  setAnswerToUpdate,
  setTestQuestionsAnswers,
} from "redux/slices/updateFormationSlice";
//import { getAddQuestionData, setFiles, setName } from "redux/slices/AddQuestionSlice"

interface UpdateAnswerProps {
  id: number;
  questionId: number;
  answerSetter: () => void;
}
const UpdateAnswerModal: React.FC<UpdateAnswerProps> = ({
  id,
  questionId,
  answerSetter,
}: UpdateAnswerProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const dispatch = useAppDispatch();
  const [add, setAdd] = useState(false);
  const [loading, setLoading] = useState(false);
  const { content } = useAppSelector(getAddQuestionData);
  const questionAnswers = useAppSelector(
    selectUpdateFormationData
  ).testQuestionsAnswers;
  const answerToUpdate = useAppSelector(
    selectUpdateFormationData
  ).answerToUpdate;

  let answerId = Math.floor(Math.random() * 10000);

  const updateAnswersSubmitHandler = (e: FormEvent) => {
    e.preventDefault();
    dispatch(
      setTestQuestionsAnswers([
        ...questionAnswers.filter((item) => item.id != id),
        answerToUpdate,
      ])
    );
    setAdd(false);
  };

  return (
    <>
      <IconButton
        icon={<MdUpdate />}
        onClick={() => {
          answerSetter();

          onOpen();
        }}
        colorScheme={"brandScheme"}
        aria-label={""}
      />

      {answerToUpdate != null ? (
        <Modal closeOnOverlayClick={false} isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />

          {loading === true ? (
            <Spinner color="brand.500" />
          ) : (
            <ModalContent>
              <ModalHeader>Modifier une réponse</ModalHeader>
              <ModalCloseButton />
              <ModalBody pb={6}>
                <FormControl id="email">
                  <FormLabel>Contenu</FormLabel>
                  <Input
                    value={answerToUpdate.content}
                    onChange={(e) =>
                      dispatch(
                        setAnswerToUpdate({
                          ...answerToUpdate,
                          content: e.target.value,
                        })
                      )
                    }
                    borderRadius={"full"}
                    type="text"
                  />
                </FormControl>

                <FormControl id="email">
                  <FormLabel>Réponse correcte?</FormLabel>
                  <RadioGroup
                    colorScheme={"brand"}
                    onChange={(val) =>
                      dispatch(
                        setAnswerToUpdate({
                          ...answerToUpdate,
                          isCorrect: val === "1" ? true : false,
                        })
                      )
                    }
                    value={answerToUpdate.isCorrect === true ? "1" : "2"}
                  >
                    <Stack direction="row">
                      <Radio value="1">Oui</Radio>
                      <Radio value="2">Non</Radio>
                    </Stack>
                  </RadioGroup>
                </FormControl>
                <Stack my={5} direction="row" spacing={"auto"}></Stack>
              </ModalBody>

              <ModalFooter>
                <Button
                  type="button"
                  onClick={(e) => {
                    updateAnswersSubmitHandler(e);
                    onClose();
                  }}
                  colorScheme="brand"
                  mr={3}
                >
                  Enregistrer
                </Button>
                <Button onClick={onClose}>Annuler</Button>
              </ModalFooter>
            </ModalContent>
          )}
        </Modal>
      ) : null}
    </>
  );
};
export default UpdateAnswerModal;
